import { createSlice } from "@reduxjs/toolkit";
import fontSizes from "../../common/fontSizes";

export const initialState = {
  layoutModeType: 'light',
  fontSize: 0
};

const changeHTMLAttribute = (attribute, value) => {
  if (document.documentElement) document.documentElement.setAttribute(attribute, value);
  return true;
}

const LayoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    changeLayoutModeAction(state, action) {
      state.layoutModeType = action.payload;
      changeHTMLAttribute("data-bs-theme", action.payload);
    },
    changeFontSizeAction(state, action) {
      state.fontSize = action.payload;
      document.body.parentNode.style.fontSize = fontSizes[action.payload]
    }
  }
});

export const {
  changeLayoutModeAction,
  changeFontSizeAction
} = LayoutSlice.actions;

export default LayoutSlice.reducer;